/** The two values a state key needs for its group to carry an eye; the design value (shown or hidden) can come first either way. */
export const EYE_VALUES: readonly string[] = ['shown', 'hidden'];

/**
 * A group whose component the page can leave out: the eye in its header stands in for a Shown | Hidden radio pair
 * on the key it names, and the group folds shut while the component is hidden, since nothing in it applies then.
 */
export class PrototypeGroupEye {
    public readonly key: string;
    private readonly button: HTMLButtonElement;
    private readonly body: HTMLElement | null;

    constructor(button: HTMLButtonElement, onPick: (key: string, value: string) => void) {
        this.button = button;
        this.key = button.getAttribute('data-prototype-group-eye') ?? '';
        this.body = button.closest('[data-prototype-group]')?.querySelector<HTMLElement>('[data-prototype-group-body]') ?? null;
        button.addEventListener('click', () => onPick(this.key, this.isShown() ? 'hidden' : 'shown'));
    }

    public sync(value: string) {
        const shown = value !== 'hidden';
        this.button.setAttribute('aria-pressed', shown.toString());
        if (this.body) {
            this.body.hidden = !shown;
        }
    }

    private isShown(): boolean {
        return this.button.getAttribute('aria-pressed') === 'true';
    }
}
